import trunc from 'trunc-html';

const filters = {
  ehTruncateHTML: function (html, stop, ellipsis) {
    if (!html || html == "null") return "";
    let parsedHtml = trunc(html,html.length).text;
    // Split the text into words
    const words = parsedHtml.split(' ');
    // Ensure we don't truncate beyond the total number of words
    const truncatedWords = words.slice(0, stop);
    // Append the ellipsis conditionally
    const truncatedText = truncatedWords.join(' ') + (words.length > stop ? ellipsis : '');
    return truncatedText;
  },
  updateUrlWithHttp(url) {
    if (!/^(?:f|ht)tps?:\/\//.test(url)) {
      url = "http://" + url;
    }
    return url;
  }
};

export default filters;